<template>
  <b-dropdown @show="initialize" :id="id" size="sm" offset="-110" container="body" variant="link" toggle-class="text-decoration-none" no-caret>
    <template #button-content>
      <div v-if="variants === 'button_default'" style="height: fit-content; outline: 1px solid #005DCA; outline-offset: -1px;" class="px-4 py-2 rounded">
        <i class="far fa-ellipsis-v"></i>
        {{ $t('app.action')}}
      </div>
      <div v-else-if="variants === 'button_icon'">
        <app-icon class="mt-1 ml-1" name="dot_option" type="outline"/>
      </div>
    </template>
    <b-dropdown-item
      href="#"
      key="loading"
      v-if="loading"
      disabled
    >
      Loading
    </b-dropdown-item>
    <b-dropdown-item
      v-else
      href="#"
      :key="option.key"
      v-for="option in options"
      @click="handleClickItem($event, item, option)"
    >
      {{option.name}}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>

import AppIcon from '@/components/app-icon';
import ActionsMenuMixin from '@/mixins/actions-menu';

export default {
  name: 'ActionsButtonMenu',
  mixins: [ActionsMenuMixin],
  components: {
    AppIcon,
  },
  props: {
    id: {
      type: [String | Number],
      default: 'dropdown-offset',
    },
    variants: {
      type: String,
      default: 'button_default',
      validator: value => ['button_icon', 'button_default'].includes(value),
    },
    invoice: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      item: {},
    };
  },
  methods: {
    handleClickItem($event, item, option) {
      $event.preventDefault();
      $event.stopPropagation();
      this.optionClicked({
        item,
        option,
      });
    },
    initialize() {
      this.loading = true;
      this.filterData.status = this.invoice.invoice_type;
      this.getEInvoiceData(this.invoice).then((res) => {
        this.item = res;
      }).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/portal-components/invoice/actions-menu/actions-button-menu.vue